import * as yup from 'yup'

const emailValidation = yup
  .string()
  .email('El formato del correo es inválido')
  .required('Este campo es requerido')

const passwordValidation = yup
  .string()
  .matches(
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/
  )
  .required('Este campo es requerido')

export const loginSchema = yup
  .object({
    email: emailValidation,
    password: passwordValidation,
  })
  .required()
